import React, { useState, useEffect } from "react";
import '../../../CreditModule/credit.scss';
import CreditDashboardEv from "./dashbaordboxchangesAbhicashEV";
import { APIS } from "../../../../../../utils/api-factory";
import { ROLE } from "../../../../../../utils/Constant";
// import Repeat from "../../Analysis/repeatAutomation";
import Repeat from "../../../CreditModule/Analysis/repeatAutomation";
import CategorHistory from "../../../Analysis/savedCategoryuser";
import TVRForm from "./TvrAnalysis";
import LoancheckForm from "./LoancheckForm";
import { getSourceOfStatementParse } from "../../../AdminActionCreator.component";
const MainTab = ({ allDetail, admin, tenant }) => {
    const [viewPage, setViewPage] = useState('dashboard');
    const [internalViewState, setInternalViewState] = useState(false);
    const [repeatUserData, setRepeatUserData] = useState(false);
    const [statementSource, setStatementSource] = useState('');
    const [repeatEmpId, setRepeatEmpId] = useState([]);
    const [empIds, setEmpIds] = useState([]);

    const pageHandler = (data) => {
        setViewPage(data);
    };
    const changeViewState = () => {
        console.log('mjh')
        setInternalViewState(!internalViewState)
    }

    const checkRepeatUser = () => {
        fetch(`${APIS.REPEAT_USER_CHECK}${allDetail.userId}`)
            .then(res => res.json())
            .then(json => {
                setRepeatUserData(json.repeatUser);
            });
    };

    const getSource = () => {
        getSourceOfStatementParse(allDetail.userId, callback => {
            setStatementSource(callback);
        });
    };

    const getEmployeesRepeat = () => {
        fetch(`${APIS.GET_ASSIGN_BY_STATUS}?status=repeat`)
            .then(res => res.json())
            .then(res => {
                setRepeatEmpId(res);
                const uniqueEmailIds = [...new Set(res.map(item => item.emailId))];
                setEmpIds(uniqueEmailIds);
            });
    };

    useEffect(() => {
        checkRepeatUser();
        getSource();
        getEmployeesRepeat();
    }, []);

    return (
        <div className="container-fluid credit-module full-height">
            <div className="row fixed-top" style={{ marginTop: '80px', zIndex: '1', background: '#fff', borderTop: '0.5px solid grey' }}>
                <div className="btn-group btn-grp-credit" role="group" aria-label="onboard-btn" style={{ fontSize: '14px', maxWidth: 'max-content' }}>
                    <button className={`btn btn-outline-primary ${viewPage === "dashboard" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('dashboard')}> Dashboard</button>

                    <button className={`btn btn-outline-primary ${viewPage === "scorehistory" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('scorehistory')}> Score Analysis</button>
                    <button className={`btn btn-outline-primary ${viewPage === "tvrForm" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('tvrForm')}> TVR</button>
                    <button className={`btn btn-outline-primary ${viewPage === "LoancheckForm" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('LoancheckForm')}> Loan Check Form</button>


                    {repeatUserData && admin?.rolelist.includes(ROLE.CRIF_DATA) && empIds.includes(admin.emailId) && (
                        <button className={`btn btn-outline-primary ${viewPage === "repeatAutomation" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('repeatAutomation')}> Repeat Automation Decision</button>
                    )}
                    {repeatUserData && (admin.emailId === 'SuperUser') && (
                        <button className={`btn btn-outline-primary ${viewPage === "repeatAutomation" ? "analysisTopTabs" : ""}`} style={{ width: '200px', background: '#fff', color: '#00000073', borderBottom: '2px solid #DBE9FF' }} onClick={() => pageHandler('repeatAutomation')}> Repeat Automation Decision</button>
                    )}
                </div>
            </div>

            <div style={{ marginTop: viewPage === 'Crif' ? '0' : '120px' }}>
                {viewPage === 'dashboard' && (

                    <CreditDashboardEv statementSource={statementSource} changeViewState={changeViewState} internalViewState={internalViewState} admin={admin} allDetail={allDetail} tenant={tenant} />
                )}
            </div>


            {viewPage === 'tvrForm' &&
                <div>
                    <TVRForm admin={admin} allDetail={allDetail} />
                </div>
            }
            {viewPage === 'LoancheckForm' &&
                <div>
                    <LoancheckForm admin={admin} allDetail={allDetail} />
                </div>
            }
            <div>
                {viewPage === 'scorehistory' && <CategorHistory admin={admin} allDetail={allDetail} />}
            </div>
            <div style={{ marginTop: viewPage === 'Crif' ? '0' : '120px' }}>
                {viewPage === 'repeatAutomation' && <Repeat allDetail={allDetail} admin={admin} />}
            </div>

        </div>
    );
};

export default MainTab;
